import styled from '@emotion/styled/macro';
import capitalize from 'lodash/capitalize';
import React from 'react';
import CloudQueueRoundedIcon from '@mui/icons-material/CloudQueueRounded';
import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';

const IntegrationIndicatorStyled = styled('span')`
  display: flex;
  align-items: center;

  font-size: 0.8em !important; // TODO: Get rid of !important
  color: #888;

  svg, span + span {
    margin-left: 0.25em;
  }

  @media(max-width: 800px) {
    span {
      display: none;
    }
  }
`;

const CloudIntegrationIndicator = ({ integration, loading }) => {

  const integrationName = capitalize(integration);

  return (
    <IntegrationIndicatorStyled title={integrationName}>
      <span>{integrationName}</span>
      {!loading
        ? <CloudQueueRoundedIcon title={integrationName} fontSize="small" />
        : <CircularProgress size={15} />}
    </IntegrationIndicatorStyled>
  );
};

CloudIntegrationIndicator.propTypes = {
  integration: PropTypes.string.isRequired,
  loading: PropTypes.bool,
};

export default CloudIntegrationIndicator;
